export var GenericStatusIndicator;
(function (GenericStatusIndicator) {
    GenericStatusIndicator["BLUE"] = "blue";
    GenericStatusIndicator["CELESTE"] = "celeste";
    GenericStatusIndicator["EXACT"] = "exact";
    GenericStatusIndicator["GREEN"] = "green";
    GenericStatusIndicator["GREY"] = "grey";
    GenericStatusIndicator["ORANGE"] = "orange";
    GenericStatusIndicator["PURPLE"] = "purple";
    GenericStatusIndicator["RED"] = "red";
    GenericStatusIndicator["WHITE"] = "white";
    GenericStatusIndicator["YELLOW"] = "yellow";
})(GenericStatusIndicator || (GenericStatusIndicator = {}));
export var StatusColor;
(function (StatusColor) {
    /** Red / 500 */
    StatusColor["RED"] = "#F04438";
    /** Orange / 500 */
    StatusColor["ORANGE"] = "#F79009";
    /** Blue / 500 */
    StatusColor["BLUE"] = "#3979FA";
    /** Green / 500 */
    StatusColor["GREEN"] = "#12B76A";
    /** Grey / 500 */
    StatusColor["GREY"] = "#B5B8BF";
    /** Yellow / 500 */
    StatusColor["YELLOW"] = "#FFEB3B";
})(StatusColor || (StatusColor = {}));
export var GenericStatusInfoTitle;
(function (GenericStatusInfoTitle) {
    GenericStatusInfoTitle["ACTION_NEEDED"] = "ACTION NEEDED";
    GenericStatusInfoTitle["APPOINTMENT_COMPLETE"] = "Appointment complete";
    GenericStatusInfoTitle["CANCELED"] = "Canceled";
    GenericStatusInfoTitle["COLLECTED"] = "Collected";
    GenericStatusInfoTitle["COMPLETED"] = "Completed";
    GenericStatusInfoTitle["CONFIRMED"] = "Confirmed";
    GenericStatusInfoTitle["CREATED"] = "Created";
    GenericStatusInfoTitle["DEFAULT"] = "Default";
    GenericStatusInfoTitle["DELIVERED"] = "Delivered";
    GenericStatusInfoTitle["DRAFT"] = "Draft";
    GenericStatusInfoTitle["FAILED"] = "Failed";
    GenericStatusInfoTitle["IN_ITINERARY"] = "In itinerary";
    GenericStatusInfoTitle["IN_PROGRESS"] = "In Progress";
    GenericStatusInfoTitle["NOT_SENT_FOR_SCHEDULING"] = "Not sent for scheduling";
    GenericStatusInfoTitle["NURSE_AT_PATIENTS"] = "Nurse at patient\u2019s";
    GenericStatusInfoTitle["NURSE_ON_THE_WAY"] = "Nurse on the way";
    GenericStatusInfoTitle["PENDING"] = "Pending";
    GenericStatusInfoTitle["PENDING_SCHEDULING"] = "Pending scheduling";
    GenericStatusInfoTitle["PROCESSING"] = "Processing";
    GenericStatusInfoTitle["READY_FOR_PACKING"] = "Ready for packing";
    GenericStatusInfoTitle["READY_FOR_SHIPMENT"] = "Ready for shipment";
    GenericStatusInfoTitle["REJECTED"] = "Rejected";
    GenericStatusInfoTitle["RESULTED"] = "Resulted";
    GenericStatusInfoTitle["RESULTS_PENDING"] = "Results pending";
    GenericStatusInfoTitle["SCHEDULED"] = "Scheduled";
    /** So far this is used for orders that will be scheduled offline */
    GenericStatusInfoTitle["SENT_FOR_SCHEDULING"] = "Sent for scheduling";
    GenericStatusInfoTitle["SHIPPED"] = "Shipped";
    GenericStatusInfoTitle["SHOPIFY_ORDER_PENDING_FINALIZATION"] = "Shopify order pending finalization";
    GenericStatusInfoTitle["SUBMITTED"] = "Submitted";
    GenericStatusInfoTitle["SUBMITTED_WITH_TRACKING"] = "Submitted with tracking";
    GenericStatusInfoTitle["VISIT_COMPLETE"] = "Visit complete";
})(GenericStatusInfoTitle || (GenericStatusInfoTitle = {}));
export var GenericStatusInfoIconName;
(function (GenericStatusInfoIconName) {
    GenericStatusInfoIconName["CANCELED"] = "canceled";
    GenericStatusInfoIconName["CHECK"] = "check";
    GenericStatusInfoIconName["CIRCLE"] = "circle";
    GenericStatusInfoIconName["COLLECTED"] = "collected";
    GenericStatusInfoIconName["DELIVERED"] = "delivered";
    GenericStatusInfoIconName["DELIVERY"] = "delivery";
    GenericStatusInfoIconName["FAILED"] = "failed";
    GenericStatusInfoIconName["SUBMITTED"] = "submitted";
    GenericStatusInfoIconName["IN_PROGRESS"] = "in-progress";
})(GenericStatusInfoIconName || (GenericStatusInfoIconName = {}));
export var StatusStyle;
(function (StatusStyle) {
    StatusStyle["CIRCLE"] = "circle";
    StatusStyle["SQUARE"] = "square";
})(StatusStyle || (StatusStyle = {}));
//# sourceMappingURL=status.js.map